import React, { useEffect, useState } from "react";
import { Input, Modal, ModalBody } from "reactstrap";
import InfoPopup from "./InfoPopup";

const EstimateModal = (props) => {
  const isGold = props.mldAssetDetails?.bondId === "gmldm0";
  const isGoldTwin = props.mldAssetDetails?.bondId === "gmld1";
  const isMld3 = props.mldAssetDetails?.bondId === "mld3";
  const isMld4 = props.mldAssetDetails?.bondId === "mld4";
  const isMld5 = props.mldAssetDetails?.bondId === "mld5";
  const [showMaturityText, setShowMaturityText] = useState(false);
  const [showEndingText, setShowEndingText] = useState(false);
  const [firstLevel, setFirstLevel] = useState(() => isGold || isGoldTwin ? 97000 : 15000);

  const title = props.mldAssetDetails?.productName;
  const handleMaturityClick = () => {
    setShowMaturityText(!showMaturityText);
  };

  const handleEndingClick = () => {
    setShowEndingText(!showEndingText);
  };

 useEffect(() => {
  if (isGold || isGoldTwin) {
    setFirstLevel(97000);
  } else if (isMld4) {
    setFirstLevel(24900);
  } else if (isMld5) {
    setFirstLevel(25000);
  } else {
    setFirstLevel(15000);
  }
}, [props.mldAssetDetails?.bondId]);


  const handleFirstLevelChange = (e) => {
    setFirstLevel(parseInt(e.target.value));
  };

  return (
    <Modal
      className="estimate-modal"
      isOpen={props.showEstimatePopup}
      toggle={props.toggleEstimatePopup}
      centered
      contentClassName="estimate-modal-content"
    >
      <ModalBody className="estimate-body">
        <div className="toggle-div" onClick={() => props.toggleEstimatePopup()}>
          <p className="toggle">
            <span class="mdi mdi-close"></span>
          </p>
        </div>
        <div className="estimate">
          <p className="text-center estimate-main ">Estimate Your Returns</p>
          <div className="header-div">
            <p className="header">{title}</p>
            <div className="points-div d-flex">
              <p className="points">
                <span class="mdi mdi-checkbox-marked-circle mr-1 text-secondary"></span>
                Min. Returns: <b>{props?.minReturns}%</b>
              </p>
              <p className="points">
                <span class="mdi mdi-checkbox-marked-circle mr-1 text-secondary"></span>
                Max. Returns: <b>{props?.maxReturns}%</b>
              </p>
              <p className="points">
                <span class="mdi mdi-checkbox-marked-circle mr-1 text-secondary"></span>
                {`${
                  props?.product === "gmldm0" || props?.product === "gmld1"
                    ? "Gold Futures MCX"
                    : "Nifty"
                } Multiplier`}
                :{" "}
                <b>
                  {(props?.mldAssetDetails?.ISIN === "INE321N07418"
                    ? "Up to "
                    : "") + props?.niftyMulitplier}
                  x
                </b>
              </p>
            </div>
          </div>
          <div className="inputs">
            <div className="d-flex justify-content-between">
              <p
                className="label text-muted"
                style={{
                  marginTop: "0.5rem",
                }}
              >
                {props.mldAssetDetails.bondId === "gmldm0" ||
                props.mldAssetDetails.bondId === "gmld1"
                  ? "Gold Futures MCX Initial Level"
                  : "Nifty Initial Level"}
                {props.mldAssetDetails.bondId !== "mld4" ? (
                  <span
                    onClick={handleMaturityClick}
                    className="mdi mdi-information-outline ml-2"
                    style={{
                      cursor: "pointer",
                      fontSize: "15px",
                      marginTop: "10px",
                    }}
                  />
                ) : (
                  <></>
                )}
              </p>
              {isMld3 ? (
                <p className="value">22154.85</p>
              ) : (
                <p className="value">{firstLevel}</p>
              )}
            </div>

            {props.mldAssetDetails.bondId !== "mld3" ? (
              <Input
                className="mt-2"
                type="range"
                min={isGold || isGoldTwin ? 80000 : 15000}
                max={isGold || isGoldTwin ? 120000 : 35000}
                step={isGold || isGoldTwin ? 500 : 1}
                value={firstLevel}
                onChange={handleFirstLevelChange}
                style={{
                  background: `linear-gradient(to right, #283A97 ${((firstLevel -
                    (isGold || isGoldTwin ? 80000 : 15000)) *
                    100) /
                    ((isGold || isGoldTwin ? 120000 : 35000) -
                      (isGold || isGoldTwin ? 80000 : 15000))}%, #ccc 0px`,
                }}
              ></Input>
            ) : (
              ""
            )}
          </div>
          <div className="hr mt-4"></div>
          <div className="inputs">
            <div className="d-flex justify-content-between">
              <p
                className="label text-muted"
                style={{
                  marginTop: "0.5rem",
                }}
              >
                {props.mldAssetDetails.bondId === "gmldm0" ||
                props.mldAssetDetails.bondId === "gmld1"
                  ? "Gold Returns"
                  : "Nifty Returns"}
              </p>
              <p className="value">{props?.niftyReturns}%</p>
            </div>

            <Input
              className="mt-3"
              type="range"
              min={
                props?.mldAssetDetails?.bondId === "gmldm0" ||
                props.mldAssetDetails.bondId === "gmld1"
                  ? -40
                  : -70
              }
              max={100}
              step={1}
              value={props?.niftyReturns}
              onChange={props?.handleNiftyReturns}
              style={{
                background: `linear-gradient(to right, #283A97 ${((parseInt(
                  props?.niftyReturns
                ) -
                  (props?.mldAssetDetails?.bondId === "gmldm0" ||
                  props.mldAssetDetails.bondId === "gmld1"
                    ? -40
                    : -70)) *
                  100) /
                  (100 -
                    (props?.mldAssetDetails?.bondId === "gmldm0" ||
                    props.mldAssetDetails.bondId === "gmld1"
                      ? -40
                      : -70))}%, #ccc 0px)`,
              }}
            ></Input>
          </div>
          <div className="hr mt-4"></div>
          <div className="inputs">
            <div className="d-flex justify-content-between">
              <p
                className="label text-muted"
                style={{
                  marginTop: "0.5rem",
                }}
              >
                {props.mldAssetDetails.bondId === "gmldm0" ||
                props.mldAssetDetails.bondId === "gmld1"
                  ? "Gold Futures MCX Ending Level"
                  : "Nifty Ending Level"}
                {props.mldAssetDetails.bondId !== "mld4" ? (
                  <span
                    onClick={handleEndingClick}
                    className="mdi mdi-information-outline ml-2"
                    style={{
                      cursor: "pointer",
                      fontSize: "15px",
                      marginTop: "10px",
                    }}
                  />
                ) : (
                  <></>
                )}
              </p>
              {/* <p className='value'>{props.niftyEndLevel ? props.niftyEndLevel : "NA"}</p> */}
              {props.mldAssetDetails.bondId === "mld3" ? (
                <p className="value">
                  {(22154.85 * (1 + props?.niftyReturns / 100)).toFixed(2) ||
                    "NA"}
                </p>
              ) : props.mldAssetDetails.bondId === "gmldm0" ||
                props.mldAssetDetails.bondId === "gmld1" ? (
                <p className="value">
                  {firstLevel * (props?.niftyReturns / 100) + firstLevel}
                </p>
              ) : props.mldAssetDetails.bondId === "mld5" ? (
                <p className="value">
                  {(
                    firstLevel +
                    (firstLevel * props.niftyReturns) / 100
                  ).toFixed(2) || "NA"}
                </p>
              ) : (
                <p className="value">
                  {props.niftyEndLevel ? props.niftyEndLevel : "NA"}
                </p>
              )}
            </div>
          </div>
          <div className="hr mt-2"></div>
          <div className="inputs">
            <div className="d-flex justify-content-between">
              <p
                className="label text-muted"
                style={{
                  marginTop: "0.5rem",
                }}
              >
                Select Investment Amount
              </p>
              <p className="value">{props?.invAmount.oroNumber(0, true)}</p>
            </div>

            <Input
              className="mt-3"
              type="range"
              min={100000}
              max={50000000}
              step={100000}
              value={props?.invAmount}
              onChange={props?.handleInvAmount}
              style={{
                background: `linear-gradient(to right, #283A97 ${((parseInt(
                  props?.invAmount
                ) -
                  100000) *
                  100) /
                  (50000000 - 100000)}%, #ccc 0px`,
              }}
            ></Input>
          </div>
          <div className="hr mt-4"></div>
          <div className="inputs">
            <div className="d-flex justify-content-between">
              <p
                className="label text-muted"
                style={{
                  marginTop: "0.5rem",
                }}
              >
                Returns on Maturity
              </p>
              {props.mldAssetDetails.bondId === "gmldm0" ? (
                <p className="value">
                  {/* {(props?.niftyReturns * 1.3).toFixed(2)}% */}
                  {(props?.niftyReturns <= 0
                    ? 0
                    : props?.niftyReturns >= 60
                    ? 60 * 1.3
                    : props?.niftyReturns * 1.3
                  ).toFixed(2)}
                  %
                </p>
              ) : props.mldAssetDetails.bondId === "gmld1" ? (
                <p className="value">
                  {/* {(props?.niftyReturns * 1.3).toFixed(2)}% */}
                  {(props?.niftyReturns <= 24.71
                    ? 24.71
                    : props?.niftyReturns >= 50
                    ? 50 * 1
                    : props?.niftyReturns * 1
                  ).toFixed(2)}
                  %
                </p>
              ) : (
                <p className="value">{props?.maturityCoupon}%</p>
              )}
            </div>
          </div>
          <div className="hr mt-4"></div>
          <div className="inputs">
            <div className="d-flex justify-content-between">
              <p
                className="label"
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <b>My investment will become</b>
              </p>
              {props.mldAssetDetails.bondId === "gmldm0" ? (
                <p className="value">
                  <p className="value">
                    {/* {(
                      props?.invAmount +
                      (props?.invAmount * (props?.niftyReturns * 1.3)) / 100
                    )?.oroNumber(0, true)} */}
                    {(
                      props?.invAmount +
                      (props?.invAmount *
                        (props?.niftyReturns <= 0
                          ? 0
                          : props?.niftyReturns >= 60
                          ? 60 * 1.3
                          : props?.niftyReturns * 1.3)) /
                        100
                    )?.oroNumber(0, true)}
                  </p>
                </p>
              ) : props.mldAssetDetails.bondId === "gmld1" ? (
                <p className="value">
                  <p className="value">
                    {/* {(
                      props?.invAmount +
                      (props?.invAmount * (props?.niftyReturns * 1.3)) / 100
                    )?.oroNumber(0, true)} */}
                    {(
                      props?.invAmount +
                      (props?.invAmount *
                        (props?.niftyReturns <= 24
                          ? 24.71
                          : props?.niftyReturns >= 50
                          ? 50 * 1
                          : props?.niftyReturns * 1)) /
                        100
                    )?.oroNumber(0, true)}
                  </p>
                </p>
              ) : (
                <p className="value">
                  {props.finalInvestmentValue
                    ? props?.finalInvestmentValue.oroNumber(0, true)
                    : "NA"}
                </p>
              )}
            </div>
          </div>
        </div>
      </ModalBody>
      <InfoPopup
        showPopUpText={showMaturityText}
        toggleInfoPopup={handleMaturityClick}
        text={
          props.mldAssetDetails.bondId === "gmldm0" ||
          props.mldAssetDetails.bondId === "gmld1"
            ? "Avg. of closing level of Gold Near Month Futures on MCX on allotment date+ ~2 weeks & Fixing dates of the next 5 months"
            : props.mldAssetDetails.bondId === "mld5"
            ? "Initial Level: Average of Nifty 50 Index levels on 20th Oct’25 & 25th Nov’25"
            : "Initial Level: Average of Nifty 50 Index levels on 29th Feb’24 & 28th Mar’24"
        }
      />
      <InfoPopup
        showPopUpText={showEndingText}
        toggleInfoPopup={handleEndingClick}
        text={
          props.mldAssetDetails.bondId === "gmldm0" ||
          props.mldAssetDetails.bondId === "gmld1"
            ? "Ending Level: Avg. of closing level of Gold Near Month Futures on MCX as on the fixing dates of the 34th to 39th month"
            : props.mldAssetDetails.bondId === "mld5"
            ? "Final Level: The Final Fixing level would be the average of Nifty 50 Index levels on 28th Sep’27 & 26th Oct’27"
            : "Final Level: The Final Fixing level would be the average of Nifty 50 Index levels on 29th Jan’26 & 26th Feb’26"
        }
      />
    </Modal>
  );
};

export default EstimateModal;
